import { Injectable } from "@angular/core";
import { TabVerifier } from "./tab-verifier.service";

@Injectable({
  providedIn: 'root'
})
export class OzonTabVerifier extends TabVerifier {

  isProduct() {
    const match = /^\/product\//g;
    return match.test(this.url.pathname);
  }

}
